import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import httpclient from "../../../components/httpclient";
import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import IsEmpty from "../../../components/helpers/IsEmpty";
import { Modal, Button, Input } from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../../components/common/Table/CustomTable";
import { renderColumns } from "./constants";
import { TiUser } from "react-icons/ti";
import AppRoutePath from "../../../router/AppRoutePath";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";

const ListProductCategory = () => {
  const [id, setId] = useState();
  const [productCode, setProductCode] = useState();
  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  const [maxExtension, setMaxExtension] = useState();
  const [records, setRecords] = useState([]);
  const [totalRecord, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [modalAdd, setModalAdd] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const history = useHistory();

  useEffect(() => {
    getData();
  }, []);

  const handleList = (record) => {
    history.push({
      pathname: `${record.id}`,
    });
  };

  const handleSubmit = (isDelete = false) => {
    setSubmitting(true);

    let data = {
      product_code: productCode,
      name: name,
      description: description,
      min_price: minPrice,
      max_price: maxPrice,
      max_extension: maxExtension,
    };

    if (IsEmpty(id)) {
      let url = `${process.env.REACT_APP_BASE_API_URL}product-category`;
      httpclient
        .POST(url, data)
        .then((response) => {
          console.log(response);
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          window.location.reload(false);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            SwalToast.fire({
              icon: "error",
              title:
                error.response.data.error?.message ||
                "Whoops, something went wrong",
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      let url = `${process.env.REACT_APP_BASE_API_URL}product-category/${id}`;
      if (isDelete === true) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            window.location.reload(false);
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data.error);
              SwalToast.fire({
                icon: "error",
                title:
                  error.response.data.error?.message ||
                  "Whoops, something went wrong",
              });
            } else {
              console.log(error);
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        httpclient
          .PUT(url, data)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            window.location.reload(false);
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data.error);
              SwalToast.fire({
                icon: "error",
                title:
                  error.response.data.error?.message ||
                  "Whoops, something went wrong",
              });
            } else {
              console.log(error);
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };

  const handleEdit = (record) => {
    setName(record.name);
    setProductCode(record.product_code);
    setMinPrice(record.min_price);
    setMaxPrice(record.max_price);
    setMaxExtension(record.max_extension);
    setDescription(record.description);
    setId(record.id);
    setModalAdd(true);
    setIsEdit(true);
  };

  const handleDelete = (record) => {
    setId(record.id);
    handleSubmit(true);
  };

  const handleCloseModal = () => {
    setModalAdd(false);
    setName("");
    setProductCode("");
    setDescription("");
    setMinPrice("");
    setMaxPrice("");
    setMaxExtension("");
    setId("");
  };

  const getData = () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories?name=${search}&page=${page}&size=${pageSize}`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);
        console.log(response);

        setRecords(response.data.data.items);
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const searchData = (name) => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearch(name);
    setSearchTimeout(
      setTimeout(function () {
        getData();
      }, 700)
    );
  };

  return (
    <>
      <div>
        <div className="px-3">
          <div
            className="py-4 d-flex justify-content-between"
            style={{ fontSize: "13px" }}
          >
            <div className="">
              <Title text={"Daftar Kategori Produk"} />
              <Breadcrumb current={"Kategori Produk"} />
            </div>
            <div
              style={{
                padding: 13,
                border: "1px solid #DCDCDC",
                borderRadius: 5,
                height: 50,
                width: 222,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#303030",
                }}
              >
                <TiUser
                  style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                />
                <span style={{ fontWeight: 700 }}>{records.length}</span> Total
                Kategori
              </div>
            </div>
          </div>
          <div className="d-flex pt-3 align-items-end">
            <div className="">
              <p className="m-0">Nama Kategori:</p>
              <input
                type="text"
                className="form-control border-97A0AE"
                placeholder="Nama Kategori"
                onChange={(e) => searchData(e.target.value)}
              />
            </div>
            {/* <CanAccess
              role={AuthorizationList.create_product}
              yes={
                <div
                  className="ml-auto"
                  onClick={() => {
                    setModalAdd(true);
                    setIsEdit(false);
                  }}
                >
                  <button className="ml-3 btn border-438EBC bgc-2C465C text-white font-weight-semi-bold">
                    + Tambah Kategori
                  </button>
                </div>
              }
            /> */}
          </div>
          <div style={{ marginTop: 24 }}>
            <CustomTable
              columns={renderColumns(handleEdit, handleDelete, handleList)}
              data={records}
              loading={loading}
              // handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>

      <Modal
        className="modal-add"
        centered
        title={`${isEdit ? "Ubah" : "Tambah"} Kategori`}
        visible={modalAdd}
        onOk={handleSubmit}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            disabled={submitting}
            onClick={handleSubmit}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Simpan
          </Button>,
        ]}
      >
        <div className="d-flex align-items-center mt-3">
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Kode Produk :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Kode Produk"
              value={productCode}
              onChange={(e) => setProductCode(e.target.value)}
            />
          </div>
        </div>
        <div className="d-flex align-items-center  my-3">
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Nama Kategori :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Nama Kategori"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>
        <div className="d-flex align-items-center  my-3">
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Deskripsi :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input.TextArea
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Deskripsi"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>
        <div className="d-flex align-items-center my-3">
          <div style={{ flex: 1 }}>
            <div className="color-A6A6A6">Harga Minimal :</div>
          </div>
          <div className="d-flex align-items-center" style={{ flex: 2 }}>
            <NumberFormat
              className="form-control border-DCDCDC text-input"
              isNumericString={true}
              value={minPrice}
              onValueChange={(e) => setMinPrice(e.floatValue)}
              thousandSeparator={"."}
              decimalSeparator={","}
              style={{
                marginRight: 5,
                border: "0.75px solid #DCDCDC",
                width: "100%",
                paddingLeft: 6,
                height: 36,
                borderRadius: 5,
                flex: 1,
              }}
            />
            <div className="color-A6A6A6 ml-1" style={{ flex: 0.2 }}>
              Rupiah
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center  my-3">
          <div style={{ flex: 1 }}>
            <div className="color-A6A6A6">Harga Maksimal :</div>
          </div>
          <div className="d-flex align-items-center" style={{ flex: 2 }}>
            <NumberFormat
              className="form-control border-DCDCDC text-input"
              isNumericString={true}
              value={maxPrice}
              onValueChange={(e) => setMaxPrice(e.floatValue)}
              thousandSeparator={"."}
              decimalSeparator={","}
              style={{
                flex: 1,
                marginRight: 5,
                border: "0.75px solid #DCDCDC",
                width: "100%",
                paddingLeft: 6,
                height: 36,
                borderRadius: 5,
              }}
            />
            <div className="color-A6A6A6 ml-1" style={{ flex: 0.2 }}>
              Rupiah
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center my-3">
          <div style={{ flex: 1 }}>
            <div className="color-A6A6A6">Max Extension :</div>
          </div>
          <div className="d-flex align-items-center" style={{ flex: 2 }}>
            <NumberFormat
              className="form-control border-DCDCDC text-input"
              isNumericString={true}
              value={maxExtension}
              onValueChange={(e) => setMaxExtension(e.floatValue)}
              thousandSeparator={"."}
              decimalSeparator={","}
              style={{
                flex: 1,
                marginRight: 5,
                border: "0.75px solid #DCDCDC",
                width: "100%",
                paddingLeft: 6,
                height: 36,
                borderRadius: 5,
              }}
            />
            <div className="color-A6A6A6 ml-1" style={{ flex: 0.2 }}>
              Hari
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ListProductCategory;
